"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["Pending"] = 0] = "Pending";
    OrderStatus[OrderStatus["Accepted"] = 1] = "Accepted";
    OrderStatus[OrderStatus["Declined"] = 2] = "Declined";
    OrderStatus[OrderStatus["Confirmed"] = 3] = "Confirmed";
    OrderStatus[OrderStatus["Cancelled"] = 4] = "Cancelled";
    OrderStatus[OrderStatus["TimedOut"] = 5] = "TimedOut";
    OrderStatus[OrderStatus["Draft"] = 6] = "Draft";
    OrderStatus[OrderStatus["Reserved"] = 7] = "Reserved";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
//# sourceMappingURL=OrderStatus.js.map